exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n}\n:host a,\n:host p {\n  color: #fff;\n  font-weight: bold;\n}\n.rm-section-title {\n  color: #fff;\n}\n.rm-image,\n.rm-filter,\n.container {\n  height: 100%;\n  width: 100%;\n}\n.rm-image {\n  background: url(\"/assets/me-mountain-alt.jpg\");\n  background-size: cover;\n  background-position: 50% 40%;\n}\n.rm-filter {\n  background: rgba(87,67,15,0.2);\n}\na.rm-btn {\n  color: #fafafa;\n  border: solid 1px #000;\n  background: none;\n  border-radius: 0;\n  padding: 2em 1em;\n  -webkit-transition: background 200ms, color 200ms;\n  transition: background 200ms, color 200ms;\n  background: rgba(0,0,0,0.3);\n}\na.rm-btn:hover {\n  background: rgba(0,0,0,0.4);\n  color: #fafafa;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/davcocom/Documents/Documents - David’s MacBook Pro/resume/resume-onepage/src/app/contact/contact.component.styl
// module id = ../../../../../src/app/contact/contact.component.styl
// module chunks = main